<script>
import TaxStateNotSupported from '@/views/meitav-dash/open-fund/dialogs/TaxStateNotSupported';

export default {
  name: 'TaxStateNotSupportedHelper',
  computed: {
    shouldShowTaxStateNotSupportedDialog() {
      return this.isUsaResident || this.isPayingUsaTax || this.isOecd;
    },
  },
  methods: {
    openTaxNotSupportedDialog() {
      this.$q.dialog({
        component: TaxStateNotSupported,
        parent: this,
      });
    },
  },
};
</script>
